import React from 'react';

const ShortsIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00001 12.65V7.35L12 10L7.00001 12.65ZM14.77 8.32C14 8 13.57 7.82 13.57 7.82L15 7.06C16.84 6.1 17.53 3.83 16.56 2C15.59 0.169999 13.32 -0.530001 11.49 0.439999L3.00001 4.94C1.71001 5.62 0.930014 6.98 1.00001 8.43C1.07001 9.85 1.93001 11.1 3.22001 11.68C3.25001 11.69 4.42001 12.18 4.42001 12.18L3.00001 12.93C1.17001 13.9 0.470014 16.17 1.44001 18C2.41001 19.83 4.68001 20.53 6.51001 19.56L15.01 15.06C16.3 14.38 17.07 13.02 17 11.57C16.93 10.15 16.06 8.89 14.77 8.32V8.32ZM14.54 14.18L6.04001 18.68C4.70001 19.39 3.03001 18.88 2.32001 17.54C1.61001 16.2 2.12001 14.53 3.46001 13.82L5.50001 12.74V11.53L4.81001 11.25L3.70001 10.79C2.71001 10.38 2.05001 9.44 2.00001 8.38C1.95001 7.32 2.52001 6.32 3.46001 5.82L11.96 1.32C13.3 0.609999 14.97 1.12 15.68 2.46C16.39 3.8 15.88 5.47 14.54 6.18L12.5 7.26V8.47L14.3 9.21C15.29 9.62 15.95 10.56 16 11.62C16.05 12.68 15.48 13.68 14.54 14.18Z"
        fill="black"
      />
    </svg>
  );
};

export default ShortsIcon;
